import { render, staticRenderFns } from "./AiTokenPnl.vue?vue&type=template&id=31bed242"
import script from "./AiTokenPnl.vue?vue&type=script&lang=js"
export * from "./AiTokenPnl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports